import type { ReactNode } from 'react'
import * as SiteWideStyles from '../styles/abstract/SiteWide.css'

export const formattedMessageValues = {
  br: <br />,
  brMobile: <br className={SiteWideStyles.DisplayMobileOnly} />,
  brDesktop: <br className={SiteWideStyles.DisplayDesktopOnly} />,
  p: (chunks: ReactNode[]) => <p>{chunks}</p>,
  b: (chunks: ReactNode[]) => <b>{chunks}</b>,
  strong: (chunks: ReactNode[]) => <strong>{chunks}</strong>,
} as const
